import {
  GET_LIST_AGENCIES,
  getListAgenciesError,
  getListAgenciesStart,
  getListAgenciesSuccess,
} from "app/redux";
import { makeRequest } from "app/utils/makeRequest";
import { payload } from "app/utils/types";
import { all, call, put, takeLatest } from "redux-saga/effects";

function* listAgenciesFetchRequest(actions: payload): Generator<any, void, any> {
  try {
    const {
      payload: { address: path, key, requestParams, queryParams },
    } = actions;
    yield put(getListAgenciesStart());
    const response = yield call(() => makeRequest(path).get(key, requestParams, queryParams));
    yield put(getListAgenciesSuccess(response.data));
  } catch (error: any) {
    yield put(getListAgenciesError(error));
  }
}

function* watchListAgenciesSagas() {
  yield takeLatest(GET_LIST_AGENCIES, listAgenciesFetchRequest);
}

export default function* listAgenciesSaga() {
  yield all([watchListAgenciesSagas()]);
}
